<template>
  <div id="app">
    <!-- <pre>{{memberData}}</pre> -->
    <div class="location" v-if="userLocation && stripeLocale[userLocation.countryCode]">
      <!-- <pre>{{userLocation}}</pre> -->
      <div class="location__flag">{{stripeLocale[userLocation.countryCode].flag}}</div>
    </div>
    <!-- <pre v-if="userLocation">{{userLocation}}</pre> -->
    <div v-bind:class="{'loading--active': loadingIndicator}" class="loading">
      <div class="loading__inner">
        <i class="fas fa-spinner fa-pulse fa-3x fa-fw" />
      </div>
    </div>

    <Register
      class="screen"
      v-bind:class="{'active': this.activeScreen === 'welcome'}"
      :loading-indicator="loadingIndicator"
      @loading="setLoading"
      :api-base="apiBase"
      :subscription="subscription"
      @next="finishRegistration"
    />

    <WhyRunning
      class="screen"
      v-bind:class="{'active': this.activeScreen === 'whyRunning'}"
      :loading-indicator="loadingIndicator"
      v-if="this.activeScreen === 'whyRunning'"
      @next="finishWhyRunning"
      :member="memberData"
    />

    <SelectPlan
      class="screen"
      v-bind:class="{'active': this.activeScreen === 'selectPlan'}"
      :loading-indicator="loadingIndicator"
      @next="finishSelectPlan"
      :member="memberData"
      :stripe-plans="stripePlans"
    />

    <Payment
      class="screen"
      v-bind:class="{'active': this.activeScreen === 'payment'}"
      :loading-indicator="loadingIndicator"
      @next="finishPayment"
      :member="memberData"
      :stripe-key="stripeKey"
      :selected-plan="selectedPlan"
    />

    <Account
      :loading-indicator="loadingIndicator"
      :api-base="apiBase"
      :member="memberData"
      :subscription="subscription"
      v-bind:class="{'active': this.activeScreen === 'account'}"
      class="screen"
      @logout="endSession"
    />
    <!-- <EnterEmail v-bind:class="{'active': this.activeScreen === 'enterEmail'}" class="screen" @next="finishRegistration" :fb-data="fbData" :fb-auth="fbAuth" /> -->

    <Download
      v-bind:class="{'active': this.activeScreen === 'download'}"
      class="screen"
      @done="end"
    />
  </div>
</template>

<script>
/* global dataLayer */
/* global analytics */
import moment from 'moment'
import Account from './components/Account'
// import EnterEmail from './components/EnterEmail'
// import Welcome from './components/Welcome'
import Register from './components/Register'
import WhyRunning from './components/WhyRunning'
import SelectPlan from './components/SelectPlan'
import Payment from './components/Payment'
import Download from './components/Download'

export default {
  name: 'App',
  data () {
    return {
      userLocation: {
        // countryCode: 'US'
      },

      loadingIndicator: false,
      session: null,
      environment: this.$parent.environment,
      stripeLocale: this.$parent.stripeLocale,
      stripeKey: this.$parent.stripeKey,
      stripePlans: null,
      apiBase: this.$parent.apiBase,
      activeScreen: null,
      memberData: null,
      subscription: null,
      fbAuth: null,
      fbData: null,
      whyRunning: null,
      selectedPlan: null,
      stripeToken: null,

      registerComplete: false,
      whyRunningComplete: false,
      selectPlanComplete: false,
      paymentComplete: false
    }
  },
  components: {
    Register,
    WhyRunning,
    SelectPlan,
    Payment,
    Download,
    Account
  },
  methods: {
    handleErrors: function (response) {
      if (!response.ok) {
        throw Error(response.statusText)
      }
      return response
    },
    endSession: function () {
      console.log('Session ending')
      this.$cookie.delete('__studio', { domain: '.studio.live' })
      this.activeScreen = 'welcome'
    },
    setLoading: function (status) {
      console.log(status)
      console.log('!!!!!!')
      this.loadingIndicator = status
    },
    subscriptionDetails: function () {
      return fetch(
        `${this.apiBase}/users/${this.memberData.id}/current-subscription`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.memberData.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        }
      ).then(response => {
        if (response.status === 402 || response.status === 500) {
          this.subscription = null
          return this.subscription
        } else {
          return response.json().then(currentSubscription => {
            this.subscription = currentSubscription.current_subscription

            this.subscription.summary = {
              active:
                this.subscription.is_active ||
                moment(this.custom_expires_date).isAfter(),
              trial: {
                active: this.subscription.is_trial_period,
                started: {
                  original: moment(this.subscription.trial_start_date),
                  long: moment(this.subscription.trial_start_date).format(
                    'dddd, MMMM Do YYYY, h:mma'
                  ),
                  formatted: moment(this.subscription.trial_start_date).format(
                    'MM/DD/YYYY'
                  ),
                  calendar: moment(
                    this.subscription.trial_start_date
                  ).calendar(),
                  fromNow: moment(this.subscription.trial_start_date).fromNow()
                }
              },
              expires: {
                original: moment(this.subscription.expires_date),
                long: moment(this.subscription.expires_date).format(
                  'dddd, MMMM Do YYYY, h:mma'
                ),
                formatted: moment(this.subscription.expires_date).format(
                  'MM/DD/YYYY'
                ),
                calendar: moment(this.subscription.expires_date).calendar(),
                fromNow: moment(this.subscription.expires_date).fromNow()
              },
              purchased: {
                original: moment(this.subscription.purchase_date),
                long: moment(this.subscription.purchase_date).format(
                  'dddd, MMMM Do YYYY, h:mma'
                ),
                formatted: moment(this.subscription.purchase_date).format(
                  'MM/DD/YYYY'
                ),
                calendar: moment(this.subscription.purchase_date).calendar(),
                fromNow: moment(this.subscription.purchase_date).fromNow()
              },
              created: {
                original: moment(this.memberData.created_at),
                long: moment(this.memberData.created_at).format(
                  'dddd, MMMM Do YYYY, h:mma'
                ),
                formatted: moment(this.memberData.created_at).format(
                  'MM/DD/YYYY'
                ),
                calendar: moment(this.memberData.created_at).calendar(),
                fromNow: moment(this.memberData.created_at).fromNow()
              },
              custom: {
                active:
                  this.subscription.custom_expires_date &&
                  moment(this.subscription.custom_expires_date).isAfter(),
                original: moment(this.subscription.custom_expires_date),
                long: moment(this.subscription.custom_expires_date).format(
                  'dddd, MMMM Do YYYY, h:mma'
                ),
                formatted: moment(this.subscription.custom_expires_date).format(
                  'MM/DD/YYYY'
                ),
                calendar: moment(
                  this.subscription.custom_expires_date
                ).calendar(),
                fromNow: moment(this.subscription.custom_expires_date).fromNow()
              },

              gateway: this.subscription.gateway === 'STP' ? 'stripe' : 'apple',
              type: this.subscription.identifier
                .replace('live.studio.ios.', '')
                .replace('FullService', '')
                .toLowerCase()
            }

            return this.subscription
          })
        }
      })
    },
    _subscriptionDetails: function () {
      return fetch(
        `${this.apiBase}/users/${this.memberData.id}/current-subscription`,
        {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${this.memberData.token}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        }
      ).then(response => {
        return response.json().then(subscriptionRecord => {
          this.subscription = subscriptionRecord
          if (response.status === 500) {
            this.subscription = false
            return this.subscription
          } else {
            this.subscription.summary = {
              active: subscriptionRecord.is_active,
              trial: {
                active: subscriptionRecord.is_trial_period,
                started: {
                  original: moment(subscriptionRecord.trial_start_date),
                  long: moment(subscriptionRecord.trial_start_date).format(
                    'dddd, MMMM Do YYYY, h:mma'
                  ),
                  formatted: moment(subscriptionRecord.trial_start_date).format(
                    'MM/DD/YYYY'
                  ),
                  calendar: moment(
                    subscriptionRecord.trial_start_date
                  ).calendar(),
                  fromNow: moment(subscriptionRecord.trial_start_date).fromNow()
                }
              },
              expires: {
                original: moment(subscriptionRecord.expires_date),
                long: moment(subscriptionRecord.expires_date).format(
                  'dddd, MMMM Do YYYY, h:mma'
                ),
                formatted: moment(subscriptionRecord.expires_date).format(
                  'MM/DD/YYYY'
                ),
                calendar: moment(subscriptionRecord.expires_date).calendar(),
                fromNow: moment(subscriptionRecord.expires_date).fromNow()
              },
              purchased: {
                original: moment(subscriptionRecord.purchase_date),
                long: moment(subscriptionRecord.purchase_date).format(
                  'dddd, MMMM Do YYYY, h:mma'
                ),
                formatted: moment(subscriptionRecord.purchase_date).format(
                  'MM/DD/YYYY'
                ),
                calendar: moment(subscriptionRecord.purchase_date).calendar(),
                fromNow: moment(subscriptionRecord.purchase_date).fromNow()
              },
              created: {
                original: moment(this.memberData.created_at),
                long: moment(this.memberData.created_at).format(
                  'dddd, MMMM Do YYYY, h:mma'
                ),
                formatted: moment(this.memberData.created_at).format(
                  'MM/DD/YYYY'
                ),
                calendar: moment(this.memberData.created_at).calendar(),
                fromNow: moment(this.memberData.created_at).fromNow()
              },
              gateway:
                subscriptionRecord.gateway === 'STP' ? 'stripe' : 'apple',
              type: subscriptionRecord.identifier
                .replace('live.studio.ios.', '')
                .replace('FullService', '')
                .toLowerCase()
            }

            return this.subscription
          }
        })
      })
    },
    finishRegistration: function (member) {
      this.registerComplete = true
      this.memberData = member
      this.loadingIndicator = true

      let cookieData = {
        id: member.id,
        token: member.token
      }
      cookieData = JSON.stringify(cookieData)
      this.$cookie.set('__studio', window.btoa(cookieData), {
        expires: '1M',
        domain: '.studio.live'
      })

      let intercomData = this.memberData
      intercomData.is_web_signup = true
      analytics.identify(member.id, intercomData)
      dataLayer.push({ event: 'registration_start' })
      if (member.why_running_with) {
        // todo make distinction between invalid and expired

        console.log(this.subscription)
        let _this = this
        this.subscriptionDetails().then(function (subscription) {
          if (subscription != null) {
            console.log('****** | has active subscription')
            console.log('****** | forwarding to account')

            _this.activeScreen = 'account'
            _this.loadingIndicator = false
          } else {
            console.log('****** | has NO active subscription')
            console.log('****** | forwarding to selectPlan')
            _this.activeScreen = 'selectPlan'
            _this.loadingIndicator = false
          }
        })
      } else {
        intercomData.is_web_signup = true
        intercomData.affiliation = 'Web Checkout - V5 - Intl'
        intercomData.email_ = this.memberData.email
        analytics.track('CompleteRegistration', intercomData)

        this.activeScreen = 'whyRunning'
        this.loadingIndicator = false
      }

      //   this.loadingIndicator = false
    },
    hasActiveSubscription: function () {
      let subscription = this.memberData.subscription
      let subscriptionData = this.memberData.subscription_data

      if (subscription && subscriptionData) {
        let iap = this.memberData.subscription_data.iap
        let expiresDate = moment(iap.expires_date, 'YYYY-MM-DDTHH:mm:ssZ')
        let isActive = expiresDate.isAfter()

        return isActive
      } else {
        return false
      }
    },

    finishWhyRunning: function (whyRunning) {
      this.loadingIndicator = true
      this.whyRunning = whyRunning
      this.whyRunningComplete = true

      const whyRunningParams = {
        why_running_with: this.whyRunning.key,
        location:
          this.userLocation.regionName + ', ' + this.userLocation.country
      }

      fetch(`${this.apiBase}/users/${this.memberData.id}`, {
        method: 'PATCH',
        body: JSON.stringify(whyRunningParams),
        headers: {
          Authorization: `Bearer ${this.memberData.token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        console.log(`
        ##############################################################
        ### B. WHY RUNNING SET
        ### ${this.whyRunning.key},  ${this.whyRunning.description}
        ##############################################################
        `)
        analytics.identify(this.memberData.id, whyRunningParams)
        whyRunningParams.affiliation = 'Web Checkout - V5 - Intl'
        analytics.track('why_run_completed', {
          is_web_signup: true,
          email: this.memberData.email,
          reason: this.whyRunning.description
        })
      })

      // let subscription = this.memberData.subscription
      // let subscriptionData = this.memberData.subscription_data
      //
      // if (subscription && subscriptionData) {
      //   let subscriptionExpires = (new Date(subscriptionData.iap.expires_date.split(' Etc/GMT')[0])).getTime()
      //   let now = (new Date()).getTime()
      //   let status = subscriptionExpires > now

      //   if (this.hasActiveSubscription()) {
      //     // window.location = '//dev-community.studio.live/account'

      //     this.activeScreen = 'account'
      //     this.loadingIndicator = false
      //   } else {
      //     this.activeScreen = 'selectPlan'
      //     this.loadingIndicator = false
      //   }

      let _this = this
      this.subscriptionDetails().then(function (subscription) {
        if (subscription) {
          console.log('****** | has active subscription')
          console.log('****** | forwarding to account...')
          _this.activeScreen = 'account'
          _this.loadingIndicator = false
        } else {
          console.log('****** | has NO active subscription')
          console.log('****** | forwarding to payment...')
          _this.activeScreen = 'selectPlan'
          _this.loadingIndicator = false
        }
      })
    },
    finishSelectPlan: function (selected) {
      console.log(selected.id)
      this.selectedPlan = selected

      this.loadingIndicator = true
      this.activeScreen = 'payment'
      this.selectPlanComplete = true
      this.loadingIndicator = false

      console.log(`
      ##############################################################
      ### C. SELECT PLAN
      ### ${this.selectedPlan.id}, 
      ### ${this.selectedPlan.type}, ${JSON.stringify(this.selectedPlan)}
      ##############################################################
      `)

      const initiateCheckoutParams = {
        product_id: this.selectedPlan.id,
        selected_plan_type: this.selectedPlan.type,
        ip: this.userLocation.query,
        country: this.userLocation.country
      }

      initiateCheckoutParams.email = this.memberData.email
      initiateCheckoutParams.affiliation = 'Web Checkout - V5 - Intl'
      analytics.track('initiate_checkout', initiateCheckoutParams)

      if (this.selectedPlan.type === 'yearly') {
        dataLayer.push({ event: 'initiate_checkout_annual' })
      }
      if (this.selectedPlan.type === 'monthly') {
        dataLayer.push({ event: 'initiate_checkout_monthly' })
      }
    },
    finishPayment: function (stripeData) {
      this.stripeData = stripeData
      this.stripeToken = stripeData.token
      this.activeScreen = 'account'
      this.paymentComplete = true
      this.loadingIndicator = true

      const stripeParams = {
        plan_id: this.selectedPlan.id,
        token: this.stripeToken.id
      }
      fetch(`${this.apiBase}/users/${this.memberData.id}/subscribe`, {
        method: 'POST',
        body: JSON.stringify(stripeParams),
        headers: {
          Authorization: `Bearer ${this.memberData.token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.status === 200) {
          console.log(`
        ${response.status}
        ##############################################################
        ### D. PAYMENT DONE
        ### ${JSON.stringify(stripeParams)}
        ----
        ${JSON.stringify(this.selectedPlan)}
        ##############################################################
        `)

          if (this.selectedPlan.type === 'yearly') {
            dataLayer.push({
              user_email: this.memberData.email,
              event: 'start_trial_annual'
            })
          }
          if (this.selectedPlan.type === 'monthly') {
            dataLayer.push({
              user_email: this.memberData.email,
              event: 'start_trial_monthly'
            })
          }

          this.loadingIndicator = false

          analytics.track('Purchase', {
            // analytics.track('StartTrial', {
            id: this.memberData.id,
            email: this.memberData.email,
            affiliation: 'Web Checkout - V5 - Intl',
            currency: 'USD',
            ip: this.userLocation.query,
            country: this.userLocation.country,
            value_currency: this.stripeLocale[this.userLocation.countryCode]
              .currency,
            value: this.selectedPlan.localCost,
            value_usd: this.selectedPlan.usdCost,
            name: 'Studio Unlimited Classes',
            purchase_date: new Date(),
            expires_date: new Date(Date.now() + 12096e5),
            quantity: 1,
            product_id: this.selectedPlan.id,

            products: [
              {
                product_id: this.selectedPlan.id,
                value_currency: this.stripeLocale[this.userLocation.countryCode]
                  .currency,
                value: this.selectedPlan.localCost,
                value_usd: this.selectedPlan.usdCost,
                name: 'Studio Unlimited Classes',
                quantity: 1
              }
            ]
          })
          //
          // const patchParams = {
          //   'onboarding_finished': true
          // }
          //
          // fetch(`${this.apiBase}/users/${this.memberData.id}`, {
          //   method: 'PATCH',
          //   body: JSON.stringify(patchParams),
          //   headers: {
          //     'Authorization': `Bearer ${this.memberData.token}`,
          //     'Accept': 'application/json',
          //     'Content-Type': 'application/json'
          //   }
          // }).then((response) => {
          fetch(`${this.apiBase}/users/${this.memberData.id}`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${this.memberData.token}`,
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          }).then(response => {
            response.json().then(member => {
              this.memberData = member
              this.memberData.is_web_signup = true
              analytics.identify(this.memberData.id, this.memberData)

              let _this = this
              this.subscriptionDetails().then(function (subscription) {
                if (subscription) {
                  console.log('****** | has active subscription now')
                  console.log('****** | forwarding to account...')
                  _this.activeScreen = 'account'
                  _this.loadingIndicator = false
                } else {
                  console.log(
                    '****** | has NO active subscription for some reason'
                  )
                  console.log('****** | forwarding to select plan')
                  _this.activeScreen = 'selectPlan'
                  _this.loadingIndicator = false
                }
              })
            })
            // this.memberData = response.data
            // this.finishRegistration(this.memberData)
          })
          // })

          //   snaptr('init', '14ded41e-599d-4d94-987e-eeaf16bd7d79', {'user_email': this.memberData.email})
          //   snaptr('track', 'PAGE_VIEW')
          //   snaptr('track', 'PURCHASE', {'currency': 'USD', 'price': this.selectedPlan.revenue})
        } else {
          console.log('Expired subscription')
        }
      })
    },
    end: function () {
      console.log('Done')
    }
  },
  mounted () {
    // console.log(this.apiBase)
    console.log(this.environment)
    console.log('Epsilon')

    fetch('https://pro.ip-api.com/json/?key=v1H0V7EBJWZqqaX', {
      method: 'GET'
    }).then(response => {
      if (response.status === 200) {
        response.json().then(location => {
          this.userLocation = location
          console.log(`Region Set: ${this.userLocation.countryCode}`)
          if (window.location.hash) {
            this.userLocation.countryCode = window.location.hash.replace(
              '#',
              ''
            )
          }

          if (!this.stripeLocale[this.userLocation.countryCode]) {
            this.stripePlans = this.stripeLocale['US']
          } else {
            this.stripePlans = this.stripeLocale[this.userLocation.countryCode]
          }
        })
      } else {
        //
        console.log('some error')
      }
    })

    // console.log(this.stripeKey)
    // console.log('MONTHLY ' + this.stripePlans.monthly.id)
    // console.log('YEARLY ' + this.stripePlans.yearly.id)

    let cookie = this.$cookie.get('__studio')

    if (cookie) {
      cookie = window.atob(cookie)
      cookie = JSON.parse(cookie)

      fetch(`${this.apiBase}/users/check/auth`, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Authorization: `Bearer ${cookie.token}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }).then(response => {
        if (response.status === 200) {
          console.log('valid token')

          console.log(cookie.id)

          // this.finishRegistration(this.memberData)
          fetch(`${this.apiBase}/users/${cookie.id}`, {
            method: 'GET',
            mode: 'cors',
            headers: {
              Authorization: `Bearer ${cookie.token}`,
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          }).then(response => {
            response.json().then(member => {
              console.log(member)
              this.memberData = member
              // this.activeScreen = 'whyRunning'
              this.finishRegistration(member)
            })
            // this.memberData = response.data
            // this.finishRegistration(this.memberData)
          })
        } else {
          // this.$cookie.delete('__studio', {domain: '.studio.live'});
          this.activeScreen = 'welcome'
          console.log('invalid token')
          this.endSession()
        }
      })
    } else {
      // No cookie, show landing
      this.activeScreen = 'welcome'
    }

    // Prevent user-zoom
    document.addEventListener('gesturestart', function (e) {
      e.preventDefault()
    })
  },
  beforeCreate () {},
  created () {}
}
</script>

<style>
@import "https://meyerweb.com/eric/tools/css/reset/reset.css";
@import "./assets/css/app.css";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: #333;
}

#intercom-container > * {
  display: none !important;
}

.location {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  /* border: solid 1px blue; */
  overflow: hidden;
  /* background-color: rgba(0,0,0,0.5); */
  width: 50px;
  height: 40px;
  width: 100%;
  /* padding: 4px; */
  text-align: right;
}
.location .location__flag {
  /* width: auto; */
  /* vertical-align: middle; */
  font-size: 2em;
  padding: 9px;

  max-width: none;
}

.location__country {
  /* border: solid 1px red; */
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue